<template>
  <div :class="$style.root">
    <div :class="$style.content">
      <template v-if="query">
        {{ $t('pages.shared.noResultsFor', { query: query }) }}
      </template>
      <template v-else>
        {{ $t('pages.shared.noResults') }}
      </template>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const props = defineProps({
    query: Number || String
  })
</script>

<style module>
.root {
  composes: container font-size-large from global;

  margin-top: var(--unit--vertical);
}

.content {
  padding: var(--unit--default);
  text-align: center;

  background-color: var(--color--primary);
  color: var(--color--background);
}
</style>
